module.exports = __webpack_public_path__ + "static/media/facebook.7c7d7722.svg";